import React, {Component} from 'react';
import '../css/style-timeSelector.css';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import {DateRangePicker} from 'react-dates';
import Button from "../utils/entities/Button";
import BlockTimeSelector from "./BlockTimeSelector";
import TimeRange from "../utils/TimeRange";
//import PropTypes from "prop-types";

class TimerangeSelector extends Component {
/*
    static propTypes = {
        TimeRange: PropTypes.object.isRequired,
        translate: PropTypes.func.isRequired,
        onTimeRangeChanged: PropTypes.object.isRequired,
    };
*/
    static defaultProps = {
        displayFormat: 'MM/DD/YYYY',
    };

    constructor(props) {

        super(props);

        let timeRange = props.TimeRange ? props.TimeRange : new TimeRange();

        this.state = {
            timeRange: timeRange,
            dateType: 'current', // 'current','block' or 'range/null'
            dateCurrent: null, // only when dateType 'current': 'year','month','quarter',null
            dateBlock: null, // only when dateType 'block': '2017','2017-Q2','2017-12',null
            startDate: this.props.startDate,
            endDate: this.props.endDate,
        };

        this.translate = this.props.translate;
        this.rnd = Math.random();

        this.setBlockTimerange = this.setBlockTimerange.bind(this);
        this.setCurrentTimerange = this.setCurrentTimerange.bind(this);
        this.setRange = this.setRange.bind(this);
        this.newTimeRange = this.newTimeRange.bind(this);

    };

    /**
     * @param TimeRange timeRange
     */
    setBlockTimerange(timeRange) {

        this.newTimeRange(timeRange);

    }

    setCurrentTimerange(event, range) {

        if (event) event.preventDefault();

        let tr = this.state.timeRange.setCurrent(range);

        this.newTimeRange(tr);

    }

    setRange(obj) {

        let startDate = obj.startDate;
        let endDate = obj.endDate;

        if (obj.startDate) startDate = obj.startDate.clone().hour(0).minute(0).second(0);
        if (obj.endDate) endDate = obj.endDate.clone().hour(23).minute(59).second(59);

        const tr = this.state.timeRange.setRange(startDate, endDate);

        this.newTimeRange(tr);

    }

    /**
     * @param TimeRange timeRange
     */
    newTimeRange(timeRange) {

        this.setState({timeRange: timeRange});

        if (this.props.onTimeRangeChanged) this.props.onTimeRangeChanged(timeRange);

    }

    render() {

        return (
            <div className={"timeSelector"}>
                <DateRangePicker
                    startDateId={'startDateId' + this.rnd}
                    endDateId={'endDateId'+ this.rnd}
                    startDate={this.state.timeRange.getFromMoment()} // momentPropTypes.momentObj or null,
                    endDate={this.state.timeRange.getTillMoment()} // momentPropTypes.momentObj or null,
                    displayFormat={this.props.displayFormat}
                    startDatePlaceholderText={this.translate('startDate')}
                    endDatePlaceholderText={this.translate('endDate')}
                    onDatesChange={({startDate, endDate}) => this.setRange({
                        startDate,
                        endDate
                    })} // PropTypes.func.isRequired,
                    focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                    onFocusChange={focusedInput => this.setState({focusedInput})} // PropTypes.func.isRequired,
                    isOutsideRange={(x) => false}
                    firstDayOfWeek={1}
                    minimumNights={0}
                />

                <div className={"DateButtonPicker clearfix"}>
                    <div className={"col-md-4"}>
                        <Button Active={this.state.timeRange.isCurrent('year')}
                                Text={this.translate('thisYear')}
                                onClick={(e) => this.setCurrentTimerange(e, 'year')}
                                data-i18n="thisYear"
                        />
                    </div>

                    <div className={"col-md-4"}>
                        <Button Active={this.state.timeRange.isCurrent('quarter')}
                                Text={this.translate('thisQuarter')}
                                onClick={(e) => this.setCurrentTimerange(e, 'quarter')}
                                data-i18n="thisQuarter"
                        />
                    </div>

                    <div className={"col-md-4"}>
                        <Button Active={this.state.timeRange.isCurrent('month')}
                                Text={this.translate('thisMonth')}
                                onClick={(e) => this.setCurrentTimerange(e, 'month')}
                                data-i18n="thisMonth"
                        />
                    </div>
                </div>

                <div>
                    <BlockTimeSelector
                        TimeRange={this.state.timeRange}
                        onChange={this.setBlockTimerange}
                    />
                </div>

                {/*TimeRange: {this.state.timeRange.toString()}*/}

            </div>
        );

    }

}

export default TimerangeSelector;